const guiColors = {
    'looks-secondary': 'hsla(215, 100%, 65%, 1)',
    'looks-transparent': 'hsla(215, 100%, 65%, 0.35)',
    'looks-light-transparent': 'hsla(215, 100%, 65%, 0.15)',
    'looks-secondary-dark': 'hsla(215, 60%, 50%, 1)',
    'mode-toggle':'#78a9d6',
    'tabswitcher-tabs-equles':'#3a7bd5',
    'tabswitcher-tabs-noequles':'#c7dcf7',
    'tabswitcher-programe-down':'#d6ecff',
    'tabswitcher-control-first':'#f6f9fd',
    'tabswitcher-control-second':'#eef5ff',
    'tabswitcher-control-third':'#e0ecf8',
    'tabswitcher-serial-second':'#e0f0f8',
    'ic-main-1': '#4d97ff',//当前项目主颜色
    'ic-main-light-2': '#76aeff',//当前项目主颜色--浅色
    'ic-main-light-very-3': '#d2e2ff',//当前项目主颜色--更浅色
    'ic-main-light-pluse-4': '#f1f1ff',//当前项目主颜色--极浅色
};

const blockColors = {};

export {
    guiColors,
    blockColors
};
